"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var moment_1 = tslib_1.__importDefault(require("moment"));

var FoldButton_1 = tslib_1.__importDefault(require("../../../Buttons/FoldButton"));

var styles = tslib_1.__importStar(require("./index.style"));

var helper_1 = require("../../../../styles/helper");

var useOverflow_1 = tslib_1.__importDefault(require("../../../../hooks/useOverflow"));

function ReplyListItem(_ref) {
  var partnerName = _ref.partnerName,
      partnerReview = _ref.partnerReview,
      className = _ref.className;
  var createdAt = partnerReview.createdAt,
      comment = partnerReview.comment;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isFold = _react_1$useState2[0],
      setFold = _react_1$useState2[1];

  var partnerRef = react_1.useRef(null);
  var handleNotFold = react_1.useCallback(function () {
    setFold(false);
  }, []);
  useOverflow_1.default(partnerRef, 125, function () {
    setFold(true);
  });
  return jsx_runtime_1.jsxs("div", Object.assign({
    css: styles.wrapper,
    className: className
  }, {
    children: [jsx_runtime_1.jsx("h5", Object.assign({
      css: styles.title
    }, {
      children: partnerName
    }), void 0), jsx_runtime_1.jsx("div", Object.assign({
      css: styles.description
    }, {
      children: moment_1.default(createdAt).format('YYYY. MM. DD')
    }), void 0), jsx_runtime_1.jsx("div", Object.assign({
      ref: partnerRef,
      css: [styles.text(isFold), isFold && helper_1.multilineEllipses(5)]
    }, {
      children: comment
    }), void 0), isFold && jsx_runtime_1.jsx(FoldButton_1.default, {
      onClick: handleNotFold,
      isFold: isFold
    }, void 0)]
  }), void 0);
}

exports.default = react_1.memo(ReplyListItem);